import { render, staticRenderFns } from "./WebphoneMinimized.vue?vue&type=template&id=490e6e30&scoped=true"
import script from "./WebphoneMinimized.vue?vue&type=script&lang=js"
export * from "./WebphoneMinimized.vue?vue&type=script&lang=js"
import style0 from "./WebphoneMinimized.vue?vue&type=style&index=0&id=490e6e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e6e30",
  null
  
)

export default component.exports